import { useTranslation } from "react-i18next";
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
    FormControlLabel,
    Switch,
    CardActions,
    Autocomplete,
    TextField,
    InputAdornment
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useMemo, useState } from "react";
import { TextFieldNumber } from "src/_modules/common";
import { cloneDeep } from "lodash";
//import { useSelector } from "react-redux";


export default function RescheduleCard({
    data,
    onConfirm,
    loading,
    error,
    isSuccess,
}) {
    const { t } = useTranslation();
    //const profileAccount = useSelector(state => state.entities.profile.profile)

    const [rescheduleSetting, setRescheduleSetting] = useState({
        reschduleDeliveryDate: false,
        holidays: [],
    })

    const handleChange = ({ target: { name, value } }) => {
        setRescheduleSetting(prev => ({ ...prev, [name]: value }))
    }

    useEffect(() => {
        if (data) {
            setRescheduleSetting(data)
        }
    }, [data])

    const daysOfWeek = useMemo(() => [
        { value: 0, label: "sunday" },
        { value: 1, label: "monday" },
        { value: 2, label: "tuesday" },
        { value: 3, label: "wednesday" },
        { value: 4, label: "thursday" },
        { value: 5, label: "friday" },
        { value: 6, label: "saturday" },
    ], []);

    const confirmHandler = () => {
        onConfirm(rescheduleSetting)
    }

    return (
        <Card sx={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
            <CardHeader title={t("Reschedule order")} />
            <Divider />
            <CardContent sx={{ flex: 1 }}  >
                <FormControlLabel
                    control={
                        <Switch
                            name="reschduleDeliveryDate"
                            checked={rescheduleSetting.reschduleDeliveryDate}
                            onChange={({ target: { name, checked } }) => handleChange({ target: { name, value: checked } })}
                        />
                    }
                    label={t(rescheduleSetting?.reschduleDeliveryDate ? "Enabled" : "Disabled")} />
                <Autocomplete
                    disabled={!rescheduleSetting.reschduleDeliveryDate}
                    multiple
                    size="small"
                    options={daysOfWeek}
                    getOptionLabel={(option) => t(`week.${option.label}`)}
                    getOptionSelected={(option, value) => option.value === value.value}
                    value={daysOfWeek?.filter(option => rescheduleSetting?.holidays?.includes(option?.value)) ?? []}
                    onChange={(_, newValue) => handleChange({ target: { name: "holidays", value: newValue?.map(val => val.value) } })}
                    ChipProps={{
                        color: "primary",
                        variant: "outlined"
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label={t("Holidays")}
                            placeholder={t("Holidays")}
                            margin="normal"
                        />
                    )}
                />
            </CardContent>
            <Divider />
            <CardActions sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: 'row-reverse' }}>
                <LoadingButton
                    variant="contained"
                    loading={loading}
                    onClick={confirmHandler}
                >{t("Confirm")}
                </LoadingButton>
                {isSuccess && <Typography color="success.main">{t("Updated successfully")}</Typography>}
                {!!error && <Typography color="error">{t(error)}</Typography>}
            </CardActions>
        </Card>
    );
};

